import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { v4 } from 'uuid';

import { SEND_BUTTON_ID } from '@/constants/testIds';

import LocalizationContext from '../../localization/LocalizationContext';
import { sendFeedback } from '../../store/actions/feedback/sendFeedback';
import feedbackSelector from '../../store/selectors/feedbackSelectors';

interface Props {
  setOpenState: React.Dispatch<React.SetStateAction<boolean>>;
  isOpen: boolean;
}

const FeedbackDialog = ({ isOpen, setOpenState }: Props) => {
  const dispatch = useDispatch();
  const feedbackMessage = useSelector(feedbackSelector);
  const [message, setMessage] = useState(feedbackMessage);

  const handleMessageChange: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> = (event) => {
    setMessage(event.target.value);
  };

  const handleSubmit = () => {
    dispatch(sendFeedback({ feedback: { uuid: v4(), message } }));
    setOpenState(false);
  };

  return (
    <LocalizationContext.Consumer>
      {({ translatedStrings }) => (
        <Dialog open={isOpen} onClose={() => setOpenState(false)} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">{translatedStrings.sendFeedbackDialogTitle}</DialogTitle>
          <DialogContent>
            <DialogContentText>{translatedStrings.sendFeedbackDialogDescription}</DialogContentText>
            <TextField
              autoFocus
              id="message"
              type="text"
              fullWidth
              multiline
              minRows={3}
              value={message}
              onChange={handleMessageChange}
              inputProps={{
                maxLength: 255,
              }}
              variant="outlined"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenState(false)} variant="outlined" color="secondary">
              {translatedStrings.cancelAction}
            </Button>
            <Button data-id={SEND_BUTTON_ID} onClick={handleSubmit} variant="contained" color="primary" disabled={!message.trim()}>
              {translatedStrings.sendAction}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </LocalizationContext.Consumer>
  );
};

export default FeedbackDialog;
